import React, {useEffect, useRef} from 'react';
import {FilterLabels} from '../FilterLabels';
import 'styles/item/FilterDropdown.css';

const SortDropdown = ({selectedSortField, sortOrder, setSortField, onClose, buttonRef}) => {
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            console.log('event.target', event.target);
            if (
                popupRef.current &&
                !popupRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target) // Correct check for button
            ) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    const handleSortClick = (label) => {
        if (label === selectedSortField) {
            setSortField(label, sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(label, 'asc');
        }
    };

    const sortedLabels = FilterLabels.getAllFilterLabels();

    return (
        <div className="filter-dropdown" ref={popupRef}>
            <div className="filter-dropdown-content">
                {sortedLabels.map((label) => (
                    <div
                        key={label}
                        className={`show-toggle-button ${selectedSortField === label ? 'active' : 'inactive'}`}
                        onClick={() => handleSortClick(label)}
                    >
                        <div className="inner-dropdown-element">
                            {selectedSortField === label ? (
                                <>
                                    {sortOrder === 'asc' ? '↑' : '↓'} {FilterLabels[label].label}
                                </>
                            ) : (
                                FilterLabels[label].label
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SortDropdown;
